import React, { memo } from 'react';
import ProductSlideshow from '../../components/ProductSlideshow/ProductSlideshow';

// Memoized CategorySection component to prevent unnecessary re-renders
const CategorySection = memo(({ category }) => {
    // Skip rendering if category doesn't have products
    if (!category.products || category.products.length === 0) {
        return null;
    }

    return (
        <ProductSlideshow
            key={category.id}
            title={category.name}
            subtitle={category.description || `Discover our beautiful ${category.name.toLowerCase()} collection.`}
            items={category.products}
            showBtn={true}
        />
    );
});

CategorySection.displayName = 'CategorySection';

export default CategorySection;
